import type { DeviceIdentificationAssessmentDto } from '../api/admin';

function readGeo(obj: unknown): { lat: number; lng: number } | null {
  if (!obj || typeof obj !== 'object') return null;
  const g = obj as Record<string, unknown>;
  const lat = g.latitude ?? g.lat;
  const lng = g.longitude ?? g.lng;
  if (typeof lat === 'number' && Number.isFinite(lat) && typeof lng === 'number' && Number.isFinite(lng)) {
    return { lat, lng };
  }
  return null;
}

function geoFromPayload(payload: unknown): { lat: number; lng: number } | null {
  if (!payload || typeof payload !== 'object') return null;
  const root = payload as Record<string, unknown>;

  const flat = readGeo({ latitude: root.ipLatitude, longitude: root.ipLongitude });
  if (flat) return flat;

  const ipInfo = root.ip_info as Record<string, unknown> | undefined;
  if (ipInfo) {
    const v4 = ipInfo.v4 as Record<string, unknown> | undefined;
    const v6 = ipInfo.v6 as Record<string, unknown> | undefined;
    return readGeo(v4?.geolocation) ?? readGeo(v6?.geolocation);
  }
  return readGeo(root.geolocation);
}

/** Best-effort lat/lng from Fingerprint event payloads on assessments (newest first). */
export function extractIpGeoFromAssessments(
  assessments: DeviceIdentificationAssessmentDto[],
): { lat: number; lng: number } | null {
  const sorted = [...assessments].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  for (const row of sorted) {
    const hit =
      geoFromPayload(row.rawEventResponse) ?? geoFromPayload(row.signalSummary);
    if (hit) return hit;
  }
  return null;
}
